export const ENTERPRISE_INTAKE_SUPPORT_REQUIRED_RADIO = [
  "platformManagementModel",
  "supportLevel",
  "csmCadence",
  "contractFormat",
  "implementationTimeline",
  "whiteLabelRequirement",
  "estimatedToolBudgetRange",
];

export const ENTERPRISE_INTAKE_SUPPORT_REQUIRED_CHECKBOX = [
  "securityRequirements",
];

export const ENTERPRISE_INTAKE_SUPPORT_RADIO_OTHER_PAIRS = [
  ["supportLevel", "supportLevelOther"],
  ["csmCadence", "csmCadenceOther"],
  ["contractFormat", "contractFormatOther"],
  ["implementationTimeline", "implementationTimelineOther"],
];

export const ENTERPRISE_INTAKE_SUPPORT_CHECK_OTHER_PAIRS = [
  ["securityRequirements", "securityRequirementsOther"],
];
